/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, useState, useEffect, useRef, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './InsuranceInformation.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import moment from 'moment-timezone'
import InsuranceCompany from './InsuranceCompany'
import PolicyNumber from './PolicyNumber'
import EffectiveDate from './EffectiveDate'
import ExpiryDate from './ExpiryDate'
import {
  clearInsuranceInfoAction,
  editPermitAction,
  addPermitAction,
  editPlateNumberAction,
  insuranceCompanyAction,
  policyNumberAction,
  effectiveDateAction,
  expiryDateAction,
} from 'redux/actions'
import PreviousInsuranceInformation from './PreviousInsuranceInformation'
import BackNextButtons from 'shared/components/BackNextButtons.jsx'
import BackAnchor from '../../../../shared/components/BackAnchor'

const InsuranceInformationView = ({ t, i18n, setIsError }) => {
  const [activeTab, setActiveTab] = useState(t('insurance_retrieved_display.add_insurance_information'))
  const history = useHistory()
  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [insuranceInfo, setInsuranceInfo] = useState({
    insuranceCompany: '',
    policyNumber: '',
    effectiveDate: '',
    expiryDate: '',
  })

  const dispatch = useDispatch()
  const {
    renewalPeriod,
    plateNumber,
    vinSerialNumber,
    insuranceCompany,
    policyNumber,
    effectiveDate,
    expiryDate,
    editPlateNumber,
    permits,
    editFromConfirmation,
    vehicleType,
    commercialAquaculture,
    fishingVessel,
  } = useSelector((state) => state.app)
  const { vehicleResponse } = useSelector((state) => state.vehicleDataAPI)

  const [useExistingInsurance, setUseExistingInsurance] = useState('')
  const [insurancePosition, setInsurancePosition] = useState('')
  const [insuranceCompanyValid, setInsuranceCompanyValid] = useState('')
  const [policyNumberValid, setPolicyNumberValid] = useState('')
  const [effectiveDateValid, setEffectiveDateValid] = useState('')
  const [expiryDateValid, setExpiryDateValid] = useState('')

  const effectiveDateDayEl = useRef(null)
  const effectiveDateMonthEl = useRef(null)
  const effectiveDateYearEl = useRef(null)

  const expiryDateDayEl = useRef(null)
  const expiryDateMonthEl = useRef(null)
  const expiryDateYearEl = useRef(null)

  const [insuranceCompanyError, setInsuranceCompanyError] = useState('insurance_information.insurance_company_error')
  const [policyNumberError, setPolicyNumberError] = useState('insurance_information.policy_number_error')
  const [effectiveDateError, setEffectiveDateError] = useState('insurance_information.effective_date_error')
  const [expiryDateError, setExpiryDateError] = useState('insurance_information.expiry_date_error')

  const [errorMsg, setErrorMsg] = useState('')

  // useEffect(() => {
  //   try {
  //     setInsuranceInfo({
  //       insuranceCompany: '',
  //       policyNumber: '',
  //       effectiveDate: '',
  //       expiryDate: '',
  //     })
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }, [activeTab])

  const [isLoading, setIsLoading] = useState(true)
  const [haveInsuranceData, setHaveInsuranceData] = useState(false)

  useEffect(() => {
    try {
      if (localStorage.getItem('backAction') === 'insurance' || localStorage.getItem('backAction') === 'review') {
        let savedPermit = permitsWithInsurance.filter((permit) => permit.plateNumber === localStorage.getItem('plateNumber'))
        if (savedPermit.length === 1) {
          setHaveInsuranceData(true)
          let saveInsurancePosition = savedPermit[0].insurancePosition,
            insuranceCompany = savedPermit[0].insuranceCompany,
            policyNumber = savedPermit[0].policyNumber,
            effectiveDate = savedPermit[0].effectiveDate,
            expiryDate = savedPermit[0].expiryDate
          setInsurancePosition(saveInsurancePosition)
          setUseExistingInsurance(saveInsurancePosition === 'existing' ? true : false)
          if (saveInsurancePosition === 'existing') {
            setInsuranceInfo({
              insuranceCompany: insuranceCompany,
              policyNumber: policyNumber,
              effectiveDate: effectiveDate,
              expiryDate: expiryDate,
            })
          }
          dispatch(insuranceCompanyAction(insuranceCompany))
          dispatch(policyNumberAction(policyNumber))
          dispatch(effectiveDateAction(effectiveDate))
          dispatch(expiryDateAction(expiryDate))
        }
      }
      let permitData = getPermitData(editPlateNumber)
      if (editPlateNumber && permitData) {
        const editInsuranceCompany = permitData['insuranceCompany'] ? permitData['insuranceCompany'] : ''
        const editPolicyNumber = permitData['policyNumber'] ? permitData['policyNumber'] : ''
        const editEffectiveDate = permitData['effectiveDate'] ? permitData['effectiveDate'] : ''
        const editExpiryDate = permitData['expiryDate'] ? permitData['expiryDate'] : ''
        dispatch(insuranceCompanyAction(editInsuranceCompany))
        dispatch(policyNumberAction(editPolicyNumber))
        dispatch(effectiveDateAction(editEffectiveDate))
        dispatch(expiryDateAction(editExpiryDate))
        // setInsuranceInfo({
        //   insuranceCompany: editInsuranceCompany,
        //   policyNumber: editPolicyNumber,
        //   effectiveDate: editEffectiveDate,
        //   expiryDate: editExpiryDate
        // })
      }
      setIsLoading(false)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [])

  const checkIsPlateAndInsuranceExists = () => {
    let isExists = false
    // console.log('permitsWithInsurance', permitsWithInsurance)
    // console.log('permits', permits)
    if (permitsWithInsurance.length > 0) {
      isExists = permitsWithInsurance.filter((permit) => permit.plateNumber === plateNumber).length > 0
    }
    if (permits.length > 0) {
      isExists = permits.filter((permit) => permit.plateNumber === plateNumber).length > 0
    }
    // console.log('isExists', isExists)
    return isExists
  }

  const onNext = (nextStep) => {
    try {
      // if (!validateFields()) {
      //   //if they are explicity invalid set the error message. Otherwise they just weren't checked yet
      //   if (effectiveDateValid === false || expiryDateValid === false || insuranceCompanyValid === false || policyNumberValid === false) {
      //     setErrorMsg(t('insurance_information.you_must_enter_info'))
      //   }
      //   return
      // }
      if (editPlateNumber === '' && permitsWithInsurance.length > 0 && useExistingInsurance === '' && !haveInsuranceData) {
        setErrorMsg('insurance_information.select_option')
        return
      }
      if (validateFields()) {
        const updatedInsuranceInfo = {
          insuranceCompany,
          policyNumber,
          effectiveDate,
          expiryDate,
        }
        if (activeTab === t('insurance_retrieved_display.add_insurance_information')) {
          if (editPlateNumber) {
            dispatch(
              editPermitAction({
                ...updatedInsuranceInfo,
                plateNumber,
                vinSerialNumber,
                renewalPeriod: renewalPeriod['period'],
                renewalAmount: renewalPeriod['amount'],
                extraFees: renewalPeriod['extraFees'],
                vehicleClass: vehicleResponse['vehicleData']['vehicleClass'],
                vehicleFuelType: vehicleResponse['vehicleData']['vehicleFuelType'],
                vehicleType,
                commercialAquaculture,
                fishingVessel,
              })
            )
          } else {
            if (plateNumber) {
              !checkIsPlateAndInsuranceExists() &&
                dispatch(
                  addPermitAction({
                    ...updatedInsuranceInfo,
                    plateNumber,
                    vinSerialNumber,
                    renewalPeriod: renewalPeriod['period'],
                    renewalAmount: renewalPeriod['amount'],
                    extraFees: renewalPeriod['extraFees'],
                vehicleClass: vehicleResponse['vehicleData']['vehicleClass'],
                vehicleFuelType: vehicleResponse['vehicleData']['vehicleFuelType'],
                    vehicleType,
                    commercialAquaculture,
                    fishingVessel,
                    insurancePosition: permits.length === 0 ? 'first' : useExistingInsurance === true ? 'existing' : 'new',
                  })
                )
              // console.log('insurance case 1')
            }
          }
          dispatch(editPlateNumberAction(''))
          if (nextStep === 'next') {
            if (editFromConfirmation) {
              history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
            } else {
              history.push(`/${i18n.language}${t('routes.contact_info')}`)
            }
          } else {
            history.push(`/${i18n.language}${t('routes.add_permit')}`)
          }
        } else if (Number.isInteger(activeTab)) {
          if (insuranceInfo.insuranceCompany && insuranceInfo.policyNumber && insuranceInfo.effectiveDate && insuranceInfo.expiryDate) {
            if (plateNumber) {
              !checkIsPlateAndInsuranceExists() &&
                dispatch(
                  addPermitAction({
                    vehicleType,
                    commercialAquaculture,
                    fishingVessel,
                    plateNumber,
                    vinSerialNumber,
                    insuranceCompany: insuranceInfo.insuranceCompany,
                    policyNumber: insuranceInfo.policyNumber,
                    effectiveDate: insuranceInfo.effectiveDate,
                    expiryDate: insuranceInfo.expiryDate,
                    renewalPeriod: renewalPeriod['period'],
                    renewalAmount: renewalPeriod['amount'],
                    extraFees: renewalPeriod['extraFees'],
                vehicleClass: vehicleResponse['vehicleData']['vehicleClass'],
                vehicleFuelType: vehicleResponse['vehicleData']['vehicleFuelType'],
                    insurancePosition: permits.length === 0 ? 'first' : useExistingInsurance === true ? 'existing' : 'new',
                  })
                )
              // console.log('insurance case 2')
            }
            dispatch(editPlateNumberAction(''))
            if (nextStep === 'next') {
              if (editFromConfirmation) {
                history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
              } else {
                history.push(`/${i18n.language}${t('routes.contact_info')}`)
              }
            } else {
              history.push(`/${i18n.language}${t('routes.add_permit')}`)
            }
          } else if (editPlateNumber) {
            dispatch(
              editPermitAction({
                ...updatedInsuranceInfo,
                plateNumber,
                vinSerialNumber,
                renewalPeriod: renewalPeriod['period'],
                renewalAmount: renewalPeriod['amount'],
                extraFees: renewalPeriod['extraFees'],
                vehicleClass: vehicleResponse['vehicleData']['vehicleClass'],
                vehicleFuelType: vehicleResponse['vehicleData']['vehicleFuelType'],
                vehicleType,
                commercialAquaculture,
                fishingVessel,
              })
            )
            if (nextStep === 'next') {
              if (editFromConfirmation) {
                history.push(`/${i18n.language}${t('routes.review_confirmation')}`)
              } else {
                history.push(`/${i18n.language}${t('routes.contact_info')}`)
              }
            } else {
              history.push(`/${i18n.language}${t('routes.add_permit')}`)
            }
          } else {
            setErrorMsg(t('insurance_information.you_must_select_between'))
          }
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      // If activeTab === 0 it is previous insurance info so don't use validation on redux data
      if (Number.isInteger(activeTab) && insuranceInfo.insuranceCompany) {
        return true
      }
      let insuranceValid = false,
        policyValid = false,
        effectiveValid = false,
        expiryValid = false
      if (insuranceCompany === '') {
        setInsuranceCompanyValid(insuranceValid)
      } else {
        insuranceValid = validateInsuranceCompany(insuranceCompany)
      }
      if (policyNumber === '') {
        setPolicyNumberValid(policyValid)
      } else {
        policyValid = validatePolicyNumber(policyNumber)
      }
      if (effectiveDate === '') {
        setEffectiveDateValid(effectiveValid)
      } else {
        effectiveValid = validateEffectiveDate()
      }
      if (expiryDate === '') {
        setExpiryDateValid(expiryValid)
      } else {
        expiryValid = validateExpiryDate()
      }
      return insuranceValid && policyValid && effectiveValid && expiryValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const getPermitData = (plateNumber) => {
    try {
      let permitData = permits.filter((permitInfo) => permitInfo.plateNumber === plateNumber)
      if (permitData.length > 0) {
        return permitData[0]
      }
      return ''
    } catch (err) {
      console.log(err)
    }
  }

  const validateInsuranceCompany = (name) => {
    try {
      let insuranceValid = false,
        insuranceError = ''
      const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          if (name.length > 4) {
            if (checkInsuranceExists(name, policyNumber)) {
              insuranceError = 'insurance_information.insurance_company_error_exists'
            } else {
              insuranceValid = true
            }
          } else {
            insuranceError = 'insurance_information.insurance_company_error_less_characters'
          }
        } else {
          insuranceError = 'insurance_information.insurance_company_error_invalid'
        }
      } else {
        insuranceError = 'insurance_information.insurance_company_error'
      }
      setInsuranceCompanyValid(insuranceValid)
      setInsuranceCompanyError(insuranceError)
      return insuranceValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validatePolicyNumber = (policy) => {
    try {
      let policyValid = false,
        policyError = ''
      const regex = RegExp(/^[a-zA-Z0-9]{5,50}$/i)
      if (regex.test(policy)) {
        if (checkInsuranceExists(insuranceCompany, policy)) {
          policyError = 'insurance_information.insurance_company_error_exists'
        } else {
          policyValid = true
        }
      } else {
        policyError = 'insurance_information.policy_number_error'
      }
      setPolicyNumberValid(policyValid)
      setPolicyNumberError(policyError)
      return policyValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateEffectiveDate = () => {
    try {
      let effectiveValid = false,
        effectiveError = ''
      let dayRegex = RegExp(/^\d{2}$/)
      let monthRegex = RegExp(/^\d{2}$/)
      let yearRegex = RegExp(/^\d{4}$/)
      if (
        dayRegex.test(effectiveDateDayEl.current.value) &&
        monthRegex.test(effectiveDateMonthEl.current.value) &&
        yearRegex.test(effectiveDateYearEl.current.value)
      ) {
        let inputDate = `${effectiveDateYearEl.current.value}-${effectiveDateMonthEl.current.value}-${effectiveDateDayEl.current.value}`
        if (moment(inputDate).isValid()) {
          if (!moment(inputDate).isAfter(moment().format('YYYY-MM-DD'), 'day')) {
            if (moment(inputDate).isAfter(moment('1900-12-31').format('YYYY-MM-DD'))) {
              effectiveValid = true
            } else {
              effectiveError = 'insurance_information.effective_date_error_old'
            }
          } else {
            effectiveError = 'insurance_information.effective_date_error_future'
          }
        } else {
          effectiveError = 'insurance_information.effective_date_error_invalid'
        }
      } else {
        effectiveError = 'insurance_information.effective_date_error'
      }
      setEffectiveDateValid(effectiveValid)
      setEffectiveDateError(effectiveError)
      return effectiveValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateExpiryDate = () => {
    try {
      let expiryValid = false,
        expiryError = ''
      let dayRegex = RegExp(/^\d{2}$/)
      let monthRegex = RegExp(/^\d{2}$/)
      let yearRegex = RegExp(/^\d{4}$/)
      if (
        dayRegex.test(expiryDateDayEl.current.value) &&
        monthRegex.test(expiryDateMonthEl.current.value) &&
        yearRegex.test(expiryDateYearEl.current.value)
      ) {
        let inputDate = `${expiryDateYearEl.current.value}-${expiryDateMonthEl.current.value}-${expiryDateDayEl.current.value}`
        if (moment(inputDate).isValid()) {
          // First valid expiry date can be today so error if before today
          const firstValidExpiryDate = moment().subtract(1, 'day').format('YYYY-MM-DD')
          if (moment(inputDate).isAfter(firstValidExpiryDate, 'day')) {
            if (!moment(inputDate).isAfter(moment('2099-12-31').format('YYYY-MM-DD'))) {
              expiryValid = true
            } else {
              expiryError = 'insurance_information.expiry_date_error_old'
            }
          } else {
            expiryError = 'insurance_information.expiry_date_error_future'
          }
        } else {
          expiryError = 'insurance_information.expiry_date_error_invalid'
        }
      } else {
        expiryError = 'insurance_information.expiry_date_error'
      }
      setExpiryDateValid(expiryValid)
      setExpiryDateError(expiryError)
      return expiryValid
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const checkInsuranceExists = (insuranceCompany, policyNumber) => {
    try {
      if (editPlateNumber) {
        return false
      }
      return !haveInsuranceData
        ? permits.find(
            (insuranceInfo) =>
              insuranceInfo.insuranceCompany.toLowerCase() === insuranceCompany.toLowerCase() &&
              insuranceInfo.policyNumber.toLowerCase() === policyNumber.toLowerCase()
          )
        : false
    } catch (err) {
      console.log(err)
    }
  }

  const handleActiveTab = (e) => {
    if (activeTab === t('insurance_retrieved_display.add_insurance_information')) {
      setActiveTab(0)
    } else {
      setActiveTab(t('insurance_retrieved_display.add_insurance_information'))
    }
  }

  const handleRadioChange = (newuseExistingInsurance) => {
    setInsuranceError(false)
    if (!newuseExistingInsurance) {
      dispatch(clearInsuranceInfoAction())
    }
    setUseExistingInsurance(newuseExistingInsurance)
  }

  const [insuranceError, setInsuranceError] = useState(false)

  const handleSelectChange = (event) => {
    let selectedInsurance = event.target.value
    if (selectedInsurance !== t('insurance_retrieved_display.select_option')) {
      selectedInsurance = JSON.parse(selectedInsurance)
      setInsuranceInfo({
        insuranceCompany: selectedInsurance.insuranceCompany,
        policyNumber: selectedInsurance.policyNumber,
        effectiveDate: selectedInsurance.effectiveDate,
        expiryDate: selectedInsurance.expiryDate,
      })
      setInsuranceError(false)
    } else {
      setInsuranceError(true)
    }
  }

  const permitsWithInsurance = useMemo(() => {
    return permits.filter((permit) => permit.insuranceCompany && permit.policyNumber && permit.expiryDate && permit.effectiveDate)
  }, [permits])

  useEffect(() => {
    const newTab = useExistingInsurance && permitsWithInsurance.length > 0 ? 0 : t('insurance_retrieved_display.add_insurance_information')
    setActiveTab(editPlateNumber ? 0 : newTab)
  }, [useExistingInsurance, permitsWithInsurance, editPlateNumber])

  const insuranceForm = () => {
    return (
      <Fragment>
        <InsuranceCompany
          validateInsuranceCompany={validateInsuranceCompany}
          insuranceCompanyError={insuranceCompanyError}
          insuranceCompanyValid={insuranceCompanyValid}
          setIsError={setIsError}
        />
        <PolicyNumber
          validatePolicyNumber={validatePolicyNumber}
          policyNumberError={policyNumberError}
          policyNumberValid={policyNumberValid}
          setIsError={setIsError}
        />
        <EffectiveDate
          validateEffectiveDate={validateEffectiveDate}
          effectiveDateError={effectiveDateError}
          effectiveDateValid={effectiveDateValid}
          effectiveDateDayEl={effectiveDateDayEl}
          effectiveDateMonthEl={effectiveDateMonthEl}
          effectiveDateYearEl={effectiveDateYearEl}
          setIsError={setIsError}
        />
        <ExpiryDate
          validateExpiryDate={validateExpiryDate}
          expiryDateError={expiryDateError}
          expiryDateValid={expiryDateValid}
          expiryDateDayEl={expiryDateDayEl}
          expiryDateMonthEl={expiryDateMonthEl}
          expiryDateYearEl={expiryDateYearEl}
          setIsError={setIsError}
        />
      </Fragment>
    )
  }

  const directInsuranceForm = (
    <Fragment>
      <h3>{t('insurance_information.enter_your_valid')}</h3>
      {insuranceForm()}
    </Fragment>
  )

  const insuranceFromWithRadio = (
    <Fragment>
      <h3>{t('insurance_retrieved_display.select_previously')}</h3>
      <PreviousInsuranceInformation
        setInsuranceInfo={setInsuranceInfo}
        insuranceInfo={insuranceInfo}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        useExistingInsurance={useExistingInsurance}
        permitsWithInsurance={permitsWithInsurance}
      />
      <div
        className={[
          'help-text',
          useExistingInsurance === '' && errorMsg !== '' && 'ns-form-group-message-error',
          styles['blockquote-alert_modified'],
        ].join(' ')}
      >
        {useExistingInsurance === '' && errorMsg !== '' && (
          <div className="ns-form-error-container has-error error-msg-align">
            <i className={['fa fa-exclamation-circle', styles['icon_margin_left']].join(' ')} aria-hidden="true"></i>
            <div className="help-block">{t(errorMsg)}</div>
          </div>
        )}
        <div className="ns-radios__item">
          <input
            className="ns-radios__input"
            type="radio"
            id="useExistingInsurance"
            name=""
            value="useExistingInsurance"
            onChange={() => handleRadioChange(true)}
            checked={useExistingInsurance === true}
          />
          <label className="ns-label ns-radios__label" htmlFor="useExistingInsurance" key="useExistingInsurance">
            <span className="ns-label-span">{t('insurance_retrieved_display.use_existing_insurance')} </span>
          </label>
        </div>
        {useExistingInsurance === true && (
          <div
            className={['ns-form-group', insuranceError ? 'ns-form-group-message-error' : 'ns-form-group-message-info'].join(' ')}
            style={{ margin: '15px' }}
          >
            <label className={[insuranceError && 'has-error', 'ns-label'].join(' ')} for="typeahead2">
              {t('insurance_retrieved_display.which_insurance')}
            </label>
            <div className="select fw-20">
              <select
                id="select1"
                name="select1"
                style={{ padding: '5px', width: '15em', margin: '5px 5px 0px 5px' }}
                onChange={handleSelectChange}
              >
                <option>{t('insurance_retrieved_display.select_option')}</option>
                {permitsWithInsurance
                  .filter((insurance, index, self) => index === self.findIndex((t) => t.insuranceCompany === insurance.insuranceCompany))
                  .map((eachInsurance, i) => {
                    return (
                      <option
                        value={JSON.stringify(eachInsurance)}
                        key={i}
                        selected={insuranceInfo.insuranceCompany === eachInsurance.insuranceCompany}
                      >
                        {eachInsurance.insuranceCompany.toUpperCase()}
                      </option>
                    )
                  })}
              </select>
            </div>
          </div>
        )}
        <div className="ns-radios__item">
          <input
            className="ns-radios__input"
            type="radio"
            id="useDifferentInsurance"
            name="useDifferentInsurance"
            value="useDifferentInsurance"
            onChange={() => handleRadioChange(false)}
            checked={useExistingInsurance === false}
          />
          <label className="ns-label ns-radios__label" htmlFor="useDifferentInsurance" key="useDifferentInsurance">
            <span className="ns-label-span">{t('insurance_retrieved_display.use_new_insurance')} </span>
          </label>
        </div>
        {useExistingInsurance === false && <div style={{ marginLeft: '10px' }}>{insuranceForm()}</div>}
      </div>
    </Fragment>
  )

  return (
    <div className="container">
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <BackAnchor backPath={permitsWithInsurance.length > 1 ? 'routes.add_permit' : 'routes.your_info'} />
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-lg-8">
          <h1>{t('insurance_information.insurance_info')}</h1>
          {isLoading
            ? directInsuranceForm
            : insurancePosition === ''
            ? editPlateNumber === '' && permitsWithInsurance.length > 0
              ? insuranceFromWithRadio
              : directInsuranceForm
            : insurancePosition === 'first'
            ? directInsuranceForm
            : insuranceFromWithRadio}
        </div>
      </div>
      <div className={styles['back_next_margin']} style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <button
          style={{ margin: 0 }}
          className="btn-lg btn-primary"
          onClick={() => {
            localStorage.setItem('backAction', 'insurance')
            onNext('next')
          }}
        >
          {t('shared.next_step')}
        </button>
        {permits.length < 10 && (
          <button
            style={{ margin: 0 }}
            className="btn-lg btn-secondary"
            onClick={() => {
              localStorage.setItem('backAction', 'insurance')
              onNext('addNew')
            }}
            value={t('insurance_information.additional_next_button')}
            name={t('insurance_information.additional_next_button')}
          >
            {t('insurance_information.additional_next_button')}
          </button>
        )}
      </div>
      {/* <div className="form-group has-error" style={{ margin: '0px 0px 25px' }}>
        <div className="help-block">
          {errorMsg !== '' && <i className="fa fa-exclamation-circle" aria-hidden="true" />} {t(errorMsg)}
        </div>
      </div> */}
    </div>
  )
}

export default withTranslation('common')(InsuranceInformationView)
